module.exports = __webpack_public_path__ + "img/cardFrame_S_bd.9cb77e78.png";